export default "__VITE_ASSET__CtsCeeic__"